<template>
  <generic-container
    :title="$t('inventory input')"
    icon="sign in"
    :configurable="true"
    :show_plus="true"
    v-bind:configure_modal="configure_modal"
    v-on:add="add"
    :header_buttons="header_buttons"
  >
    <div class="ui mini feed">
      <div
        class="event"
        v-for="(input, index) in inventory_inputs"
        :key="index"
      >
        <div class="label">
          <img src="/images/icons/inventory-in.png" />
        </div>
        <div class="content">
          <div class="summary" @click="view_input(input)">
            <a class="user">{{ input.reason }}</a>
            <div class="date">{{ input.create_date | fromNow }}</div>
          </div>
          <div class="extra text">
            <div class="ui list">
              <div
                class="item"
                v-for="(prd, idx) in input.inv_input_products"
                :key="idx"
                style="padding: 0"
              >
                {{ prd.quantity }} x
                <a @click.stop="view_product(prd)">
                  {{ prd.prd_product.name }}
                </a>
              </div>
              <div
                class="item"
                v-if="input.total_products > input.inv_input_products.length"
              >
                ...({{ input.total_products }} {{ $t("total") }})
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <pre>{{ inventory_inputs }}</pre> -->
    <input-modal ref="input_modal" @success="refresh" />
    <!-- <template v-for="(mdl, index) in input_modals">
      <component
        :is="mdl"
        :key="index"
        v-on:succedded="succedded"
        v-on:destroy="destroy"
        :input_in="selected_input"
      ></component>
    </template> -->
  </generic-container>
</template>

<script>
import { local_api, error_toast } from "@/utils";
import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";
import ConfigureModal from "./InventoryInputConfigureModal";
// import InventoryInputModal from "./InventoryInputModal";
import InputModal from "./input_modal/Index";

// @ is an aliass to /src
export default {
  name: "InventoryInputComponent",
  components: {
    GenericContainer,
    InputModal,
  },
  filters: filters,
  data() {
    return {
      inventory_inputs: [],
      configure_modal: ConfigureModal,
      // input_modals: [],
      header_buttons: [
        {
          icon: "refresh",
          color: "blue",
          click: this.refresh,
          tooltip: this.$t("refresh"),
        },
      ],
      selected_input: undefined,
    };
  },
  methods: {
    add() {
      let vm = this;
      vm.$refs.input_modal.show_modal();
      // this.input_modals.push(InventoryInputModal);
    },
    succedded() {
      this.refresh();
    },
    refresh() {
      let vm = this;
      local_api(vm, "post", "/inventory/do-get-inventory-inputs")
        .then((inputs) => {
          vm.inventory_inputs = inputs;
        })
        .catch((err) => {
          error_toast(err);
        });
    },
    view_product(product) {
      this.$router.push({
        name: "ProductView",
        query: { i: product.prd_product.uuid },
      });
    },
    view_input(input) {
      // this.selected_input = input;
      // this.input_modals.push(InventoryInputModal);
      let vm = this;
      vm.$refs.input_modal.show_modal(input);
    },
    destroy() {
      // this.input_modals = [];
      this.selected_input = undefined;
      this.refresh();
    },
  },
  created() {
    this.refresh();
  },
  mounted() {},
  watch: {},
};
</script>
